<template>
  <a-drawer
      title="广告播放详细记录"
      placement="right"
      :width="'80%'"
      :visible="open"
      :closable="true"
      @close="onClose"
  >
    <a-alert
        type="info"
        show-icon
        class="mb-3"
        :message="`剧集ID：${gatherId}，时间范围：${dateRangeText}`"
    />

    <a-table
        :data-source="list"
        :columns="columns"
        :pagination="pagination"
        :loading="loading"
        rowKey="id"
        @change="handlePageChange"
        size="middle"
    >
      <template #bodyCell="{ column, record }">
        <template v-if="column.key === 'playTime'">
          {{ record.playTime }}
        </template>
      </template>
    </a-table>
  </a-drawer>
</template>

<script>
import { fetchAdDetailByGatherId } from '@/api/statistics/ad-series'

export default {
  name: 'DetailDrawer',
  props: {
    gatherId: {
      type: String,
      required: true
    },
    dateRange: {
      type: Array,
      required: true
    },
    open: {
      type: Boolean,
      required: true
    }
  },
  data () {
    return {
      loading: false,
      list: [],
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0
      },
      columns: [
        { title: '日期时间', dataIndex: 'dateStr', key: 'dateStr' },
        { title: '用户ID', dataIndex: 'userId', key: 'userId' },
        { title: '用户名称', dataIndex: 'userName', key: 'userName' },
        { title: '广告播放次数', dataIndex: 'adAmount', key: 'adAmount' },
        { title: '解锁剧集数', dataIndex: 'gatherAmount', key: 'gatherAmount' }
      ]
    }
  },
  computed: {
    dateRangeText () {
      return this.dateRange && this.dateRange.length === 2
          ? `${this.dateRange[0].format('YYYY-MM-DD')} 至 ${this.dateRange[1].format('YYYY-MM-DD')}`
          : ''
    }
  },
  watch: {
    open (val) {
      if (val) {
        this.pagination.current = 1
        this.loadData()
      }
    },
    gatherId () {
      if (this.open) {
        this.pagination.current = 1
        this.loadData()
      }
    }
  },
  methods: {
    onClose () {
      this.$emit('update:open', false)
    },
    handlePageChange (pagination) {
      this.pagination.current = pagination.current
      this.loadData()
    },
    loadData () {
      if (!this.gatherId || !this.dateRange || this.dateRange.length !== 2) return

      this.loading = true
      fetchAdDetailByGatherId({
        gatherId: this.gatherId,
        startDate: this.dateRange[0].format('YYYY-MM-DD'),
        endDate: this.dateRange[1].format('YYYY-MM-DD'),
        pageNum: this.pagination.current,
        pageSize: this.pagination.pageSize
      }).then(res => {
        this.list = res.data.records
        this.pagination.total = res.data.total
      }).finally(() => {
        this.loading = false
      })
    }
  }
}
</script>

<style scoped>
.mb-3 {
  margin-bottom: 16px;
}
</style>
